export default __webpack_public_path__ + "static/media/thirdimgd.5f658154.png";